//! NOTE This helper is render checkbox for new react-final-form forms

import type { FieldRenderProps } from 'react-final-form'

import { Checkbox } from '@components/ui/Checkbox'
import { FormControl } from '@components/ui/FormElements/FormControl'
import type { FormControlLabelProps } from '@components/ui/FormElements/FormControlLabel'
import { FormHelperText } from '@components/ui/FormElements/FormHelperText'

import { CustomFormControlLabel } from './elements'

interface RenderCheckboxProps extends FieldRenderProps<boolean | string | number, HTMLInputElement> {
  color?: 'primary' | 'secondary' | 'default'
  className?: string
  disabled?: boolean
  displayError?: boolean
}

export function RenderRffCheckbox({
  className,
  disabled = false,
  displayError = true,
  input: { name, value, onChange, checked = false, ...restInput },
  meta: { dirtySinceLastSubmit, error, submitError, touched, modifiedSinceLastSubmit },
  ...rest
}: RenderCheckboxProps) {
  const displayedError = touched && (error || (!dirtySinceLastSubmit && !modifiedSinceLastSubmit && submitError))
  const hasError = Boolean(displayedError)

  return (
    <FormControl className={className} error={hasError} data-testid={`${name}_checkbox-rff-field-form-control`}>
      <CustomFormControlLabel
        checked={checked}
        control={<Checkbox data-testid={`${name}_checkbox-rff-field-input`} {...restInput} />}
        data-testid={`${name}_checkbox-rff-field-label`}
        disabled={disabled}
        htmlFor={name}
        name={name}
        onChange={onChange}
        {...(rest as Omit<FormControlLabelProps, 'control' | 'alignControl' | 'gap'>)}
      />
      {hasError && displayError && <FormHelperText>{displayedError}</FormHelperText>}
    </FormControl>
  )
}
